// src/components/EditorToolbar.js
import React, { useCallback } from 'react';
import { FaBold, FaItalic, FaUnderline, FaLink, FaListOl, FaListUl, FaAlignLeft, FaAlignRight, FaAlignCenter, FaAlignJustify, FaIndent, FaOutdent, FaFont, FaHighlighter } from 'react-icons/fa';

const EditorToolbar = ({ editor }) => {
  // CORREÇÃO: O Hook agora é chamado no nível superior, antes de qualquer retorno condicional.
  const setLink = useCallback(() => {
    if (!editor) return; // Adicionamos uma verificação aqui dentro para segurança
    const previousUrl = editor.getAttributes('link').href;
    const url = window.prompt('URL', previousUrl);

    if (url === null) { // Cancelar
      return;
    }
    if (url === '') { // Remover link
      editor.chain().focus().extendMarkRange('link').unsetLink().run();
      return;
    }
    // Adicionar/atualizar link
    editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
  }, [editor]);

  // A condição para retornar nulo permanece, mas agora está DEPOIS da chamada do Hook.
  if (!editor) {
    return null;
  }

  return (
    <div id="toolbar">
      <span className="toolbar-group">
        <select onChange={(e) => {
            const level = e.target.value ? parseInt(e.target.value) : 0;
            if (level === 0) {
                editor.chain().focus().setParagraph().run();
            } else {
                editor.chain().focus().toggleHeading({ level }).run();
            }
        }} 
        className="toolbar-select"
        value={editor.isActive('heading') ? editor.getAttributes('heading').level : 0}
        >
          <option value="2">Cabeçalho 2</option>
          <option value="3">Cabeçalho 3</option>
          <option value="4">Cabeçalho 4</option>
          <option value="5">Cabeçalho 5</option>
          <option value="6">Cabeçalho 6</option>
          <option value="0">Parágrafo</option>
        </select>
        
      </span>
      
      <span className="toolbar-group">
        <select 
          className="toolbar-select"
          onChange={(e) => editor.chain().focus().setFontFamily(e.target.value).run()}
          value={editor.isActive('textStyle') ? editor.getAttributes('textStyle').fontFamily || '' : ''}
        >
          <option value="Arial">Arial</option>
<option value="Arial Black">Arial Black</option>
<option value="Arial Narrow">Arial Narrow</option>
<option value="Helvetica">Helvetica</option>
<option value="Helvetica Neue">Helvetica Neue</option>
<option value="Times New Roman">Times New Roman</option>
<option value="Times">Times</option>
<option value="Georgia">Georgia</option>
<option value="Verdana">Verdana</option>
<option value="Courier New">Courier New</option>
<option value="Courier">Courier</option>
<option value="Calibri">Calibri</option>
<option value="Cambria">Cambria</option>
<option value="Candara">Candara</option>
<option value="Consolas">Consolas</option>
<option value="Constantia">Constantia</option>
<option value="Corbel">Corbel</option>
<option value="Segoe UI">Segoe UI</option>
<option value="Tahoma">Tahoma</option>
<option value="Trebuchet MS">Trebuchet MS</option>
<option value="Garamond">Garamond</option>
<option value="Palatino Linotype">Palatino</option>
<option value="Book Antiqua">Book Antiqua</option>
<option value="Century Gothic">Century Gothic</option>
<option value="Lucida Sans Unicode">Lucida Sans Unicode</option>
<option value="Lucida Console">Lucida Console</option>
<option value="Gill Sans">Gill Sans</option>
<option value="Futura">Futura</option>
<option value="Franklin Gothic Medium">Franklin Gothic</option>
<option value="Rockwell">Rockwell</option>
<option value="Roboto">Roboto</option>
<option value="Roboto Condensed">Roboto Condensed</option>
<option value="Roboto Slab">Roboto Slab</option>
<option value="Open Sans">Open Sans</option>
<option value="Lato">Lato</option>
<option value="Montserrat">Montserrat</option>
<option value="Oswald">Oswald</option>
<option value="Source Sans Pro">Source Sans Pro</option>
<option value="Raleway">Raleway</option>
<option value="PT Sans">PT Sans</option>
<option value="Merriweather">Merriweather</option>
<option value="Playfair Display">Playfair Display</option>
<option value="Nunito Sans">Nunito Sans</option>
<option value="Ubuntu">Ubuntu</option>
<option value="Lora">Lora</option>
<option value="Poppins">Poppins</option>
<option value="Noto Sans">Noto Sans</option>
<option value="Inter">Inter</option>
<option value="Work Sans">Work Sans</option>
<option value="Nunito">Nunito</option>
<option value="Fira Sans">Fira Sans</option>
<option value="Quicksand">Quicksand</option>
<option value="Dosis">Dosis</option>
<option value="Rubik">Rubik</option>
<option value="Josefin Sans">Josefin Sans</option>
<option value="Bebas Neue">Bebas Neue</option>
<option value="Abel">Abel</option>
<option value="Anton">Anton</option>
<option value="Archivo">Archivo</option>
<option value="Asap">Asap</option>
<option value="Barlow">Barlow</option>
<option value="Cabin">Cabin</option>
<option value="Cairo">Cairo</option>
<option value="Comfortaa">Comfortaa</option>
<option value="Crimson Text">Crimson Text</option>
<option value="Didot">Didot</option>
<option value="Bodoni MT">Bodoni</option>
<option value="Copperplate">Copperplate</option>
<option value="Century Schoolbook">Century Schoolbook</option>
<option value="Avant Garde">Avant Garde</option>
<option value="Optima">Optima</option>
<option value="Baskerville">Baskerville</option>
<option value="Big Caslon">Big Caslon</option>
<option value="Hoefler Text">Hoefler Text</option>
<option value="Perpetua">Perpetua</option>
<option value="Rockwell Extra Bold">Rockwell Extra Bold</option>
<option value="Copperplate Gothic Light">Copperplate Gothic</option>
<option value="Brush Script MT">Brush Script</option>
<option value="Impact">Impact</option>
<option value="Haettenschweiler">Haettenschweiler</option>
<option value="Luminari">Luminari</option>
<option value="Chalkduster">Chalkduster</option>
<option value="Jazz LET">Jazz LET</option>
<option value="Marker Felt">Marker Felt</option>
<option value="Trattatello">Trattatello</option>
<option value="Papyrus">Papyrus</option>
<option value="Herculanum">Herculanum</option>
<option value="Zapfino">Zapfino</option>
<option value="American Typewriter">American Typewriter</option>
<option value="Andale Mono">Andale Mono</option>
<option value="Monaco">Monaco</option>
<option value="Bradley Hand">Bradley Hand</option>
<option value="Skia">Skia</option>
<option value="Comic Sans MS">Comic Sans MS</option>
        </select>
        <select 
          className="toolbar-select"
          onChange={(e) => editor.chain().focus().setFontSize(e.target.value + 'px').run()}
          value={editor.isActive('textStyle') ? (editor.getAttributes('textStyle').fontSize || '16px').replace('px', '') : '16'}
        >
            <option value="8">8</option>
            <option value="10">10</option>
            <option value="12">12</option>
            <option value="14">14</option>
            <option value="16">16</option>
            <option value="18">18</option>
            <option value="22">22</option>
            <option value="24">24</option>
            <option value="28">28</option>
            <option value="30">30</option>
            <option value="36">36</option>
            <option value="46">46</option>
            <option value="56">56</option>
            <option value="72">72</option>

        </select>
        <button onClick={() => editor.chain().focus().toggleBold().run()} className={editor.isActive('bold') ? 'is-active' : ''}><FaBold /></button>
        <button onClick={() => editor.chain().focus().toggleItalic().run()} className={editor.isActive('italic') ? 'is-active' : ''}><FaItalic /></button>
        <button onClick={() => editor.chain().focus().toggleUnderline().run()} className={editor.isActive('underline') ? 'is-active' : ''}><FaUnderline /></button>
      </span>

      <span className="toolbar-group">
         <div className="color-picker-wrapper">
          <FaFont style={{ color: editor.getAttributes('textStyle')?.color }} />
          <input 
              type="color" 
              onInput={event => editor.chain().focus().setColor(event.target.value).run()} 
              value={editor.getAttributes('textStyle')?.color || '#000000'} 
          />
        </div>
        <button onClick={() => editor.chain().focus().toggleHighlight().run()} className={editor.isActive('highlight') ? 'is-active' : ''}>
          <FaHighlighter />
        </button>
      </span>
      <span className="toolbar-group">
            <button
        onClick={() => editor.chain().focus().sinkListItem('listItem').run()}
        disabled={!editor.can().sinkListItem('listItem')}
    >
        <FaIndent />
    </button>
    <button
        onClick={() => editor.chain().focus().liftListItem('listItem').run()}
        disabled={!editor.can().liftListItem('listItem')}
    >
        <FaOutdent />
    </button>
        </span>
        <span className="toolbar-group">
            <button onClick={setLink} className={editor.isActive('link') ? 'is-active' : ''}>
                <FaLink />
            </button>
        </span>
       <span className="toolbar-group">
        <button onClick={() => editor.chain().focus().toggleBulletList().run()} className={editor.isActive('bulletList') ? 'is-active' : ''}><FaListUl /></button>
        <button onClick={() => editor.chain().focus().toggleOrderedList().run()} className={editor.isActive('orderedList') ? 'is-active' : ''}><FaListOl /></button>
      </span>
      
      <span className="toolbar-group">
        <button onClick={() => editor.chain().focus().setTextAlign('left').run()} className={editor.isActive({ textAlign: 'left' }) ? 'is-active' : ''}><FaAlignLeft /></button>
        <button onClick={() => editor.chain().focus().setTextAlign('center').run()} className={editor.isActive({ textAlign: 'center' }) ? 'is-active' : ''}><FaAlignCenter /></button>
        <button onClick={() => editor.chain().focus().setTextAlign('right').run()} className={editor.isActive({ textAlign: 'right' }) ? 'is-active' : ''}><FaAlignRight /></button>
        <button onClick={() => editor.chain().focus().setTextAlign('justify').run()} className={editor.isActive({ textAlign: 'justify' }) ? 'is-active' : ''}><FaAlignJustify /></button>
      </span>
    </div>
  );
};

export default EditorToolbar;